.report-header-shell{background:linear-gradient(135deg,#e2e8f0,#f8fafc 40%,#fff);border-bottom:1px solid rgba(148,163,184,.24)}.report-header-logo{width:9rem;object-fit:contain}
/*# sourceMappingURL=quarterly-report-header.component-YAMR4UE4.css.map */
